export default [
  {
    path: '/gk/ulink/index',
    name: 'ulinkIndex',
    component: () => import('../views/home/HomeView.vue'),
  },
];
